export type SzScoringValue = 'TIME_PER_REP' | 'REPS_ONLY' | 'HIT_FACTOR';

export const SZ_SCORING_LABELS: Readonly<Record<SzScoringValue, string>> = {
  TIME_PER_REP: 'Time per rep',
  REPS_ONLY: 'Reps only',
  HIT_FACTOR: 'Hit factor'
};
